import { render, staticRenderFns } from "./singleRoundGroup.vue?vue&type=template&id=1072ecad&scoped=true"
import script from "./singleRoundGroup.vue?vue&type=script&lang=js"
export * from "./singleRoundGroup.vue?vue&type=script&lang=js"
import style0 from "./singleRoundGroup.vue?vue&type=style&index=0&id=1072ecad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1072ecad",
  null
  
)

export default component.exports